<template>
    <div class="transaction">
        <Header :mainHeader="true"/>

        <div>
            <div class="containers bg-white" >
                <h4 class="fw-bold">Sales and Tax Compliance Overview</h4>
            <div class="warehouse-inventory-card-wrapper">
                <div class="warehouse-inventory-card">
                <p>Total Sales Today</p>
                <div class="total">
                    <strong>{{ todaySales }}</strong>
                    <div href="#" >
                    <span :class="daySalesRate > 0 ? 'text-success' : 'text-danger'"> {{ daySalesRate }} % </span>
                    <svg
                    v-if="daySalesRate > 0"
                    class="fill-meta-3"
                    width="10"
                    height="11"
                    viewBox="0 0 10 11"
                    fill="green"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path
                        d="M4.35716 2.47737L0.908974 5.82987L5.0443e-07 4.94612L5 0.0848689L10 4.94612L9.09103 5.82987L5.64284 2.47737L5.64284 10.0849L4.35716 10.0849L4.35716 2.47737Z"
                        fill="green"
                    />
                    </svg>
    
                    <svg
                        v-else
                        class="fill-meta-5"
                        width="10"
                        height="11"
                        viewBox="0 0 10 11"
                        fill="#FF0000"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                        d="M5.64284 7.69237L9.09102 4.33987L10 5.22362L5 10.0849L-8.98488e-07 5.22362L0.908973 4.33987L4.35716 7.69237L4.35716 0.0848701L5.64284 0.0848704L5.64284 7.69237Z"
                        fill="#FF0000"
                        />
                    </svg>
                    <span :class="daySalesRate > 0 ? 'text-success' : 'text-danger'"> than yesterday</span>
                    </div>
                </div>
                </div>
    
                <div class="warehouse-inventory-card">
                <p>Total Sales Month to date</p>
                <div class="total">
                    <strong>0</strong>
                    <a href="#">
                        <span :class="mthSalesRate > 0 ? 'text-success' : 'text-danger'">{{  mthSalesRate }} % </span>
                        <svg
                        v-if="mthSalesRate > 0"
                        class="fill-meta-3"
                        width="10"
                        height="11"
                        viewBox="0 0 10 11"
                        fill="green"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <path
                            d="M4.35716 2.47737L0.908974 5.82987L5.0443e-07 4.94612L5 0.0848689L10 4.94612L9.09103 5.82987L5.64284 2.47737L5.64284 10.0849L4.35716 10.0849L4.35716 2.47737Z"
                            fill="green"
                        />
                        </svg>
    
                        <svg
                        v-else
                        class="fill-meta-5"
                        width="10"
                        height="11"
                        viewBox="0 0 10 11"
                        fill="#FF0000"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <path
                            d="M5.64284 7.69237L9.09102 4.33987L10 5.22362L5 10.0849L-8.98488e-07 5.22362L0.908973 4.33987L4.35716 7.69237L4.35716 0.0848701L5.64284 0.0848704L5.64284 7.69237Z"
                            fill="#FF0000"
                        />
                        </svg>
                        <span :class="mthSalesRate > 0 ? 'text-success' : 'text-danger'"> than yesterday</span>
                    </a>
                </div>
                </div>
    
                <div class="warehouse-inventory-card">
                <p>Tax Month To Date</p>
                <div class="total">
                    <strong>0</strong>
                    <div>
                    <span :class="ordersRate > 0 ? 'text-success' : 'text-danger'">{{ ordersRate}} % </span>
                    <svg
                        v-if="ordersRate > 0"
                        class="fill-meta-3"
                        width="10"
                        height="11"
                        viewBox="0 0 10 11"
                        fill="green"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                        d="M4.35716 2.47737L0.908974 5.82987L5.0443e-07 4.94612L5 0.0848689L10 4.94612L9.09103 5.82987L5.64284 2.47737L5.64284 10.0849L4.35716 10.0849L4.35716 2.47737Z"
                        fill="green"
                        />
                    </svg>
    
                    <svg
                        v-else
                        class="fill-meta-5"
                        width="10"
                        height="11"
                        viewBox="0 0 10 11"
                        fill="#FF0000"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                        d="M5.64284 7.69237L9.09102 4.33987L10 5.22362L5 10.0849L-8.98488e-07 5.22362L0.908973 4.33987L4.35716 7.69237L4.35716 0.0848701L5.64284 0.0848704L5.64284 7.69237Z"
                        fill="#FF0000"
                        />
                    </svg>
    
                    <span :class="transactionRate > 0 ? 'text-success' : 'text-danger'"> than yesterday</span>
    
                    </div>
                </div>
                </div>
    
                <div class="warehouse-inventory-card">
    
                <p>Items out of stock</p>
                <div class="total">

                    <strong style="color: green;"> 0</strong>
                    <div>
                    <span :class="collectionsRate > 0 ? 'text-success' : 'text-danger'">0 % </span>
                    <svg
                        v-if="collectionsRate > 0"
                        class="fill-meta-3"
                        width="10"
                        height="11"
                        viewBox="0 0 10 11"
                        fill="green"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                        d="M4.35716 2.47737L0.908974 5.82987L5.0443e-07 4.94612L5 0.0848689L10 4.94612L9.09103 5.82987L5.64284 2.47737L5.64284 10.0849L4.35716 10.0849L4.35716 2.47737Z"
                        fill="green"
                        />
                    </svg>
    
                    <svg
                        v-else
                        class="fill-meta-5"
                        width="10"
                        height="11"
                        viewBox="0 0 10 11"
                        fill="#FF0000"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                        d="M5.64284 7.69237L9.09102 4.33987L10 5.22362L5 10.0849L-8.98488e-07 5.22362L0.908973 4.33987L4.35716 7.69237L4.35716 0.0848701L5.64284 0.0848704L5.64284 7.69237Z"
                        fill="#FF0000"
                        />
                    </svg>
    
                    <span :class="collectionsRate > 0 ? 'text-success' : 'text-danger'"> than last month</span>
                    </div>
    
                </div>
                </div>
    
    
                <div class="warehouse-inventory-card">
                    <p>Total Purchases Month to date</p>
                    <div class="total">
                        <strong>{{ monthPurchases }}</strong>
                        <div>
                        <span :class="mthPurchasesRate > 0 ? 'text-success' : 'text-danger'">{{ mthPurchasesRate}} % </span>
                        <svg
                            v-if="mthPurchasesRate > 0"
                            class="fill-meta-3"
                            width="10"
                            height="11"
                            viewBox="0 0 10 11"
                            fill="green"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                            d="M4.35716 2.47737L0.908974 5.82987L5.0443e-07 4.94612L5 0.0848689L10 4.94612L9.09103 5.82987L5.64284 2.47737L5.64284 10.0849L4.35716 10.0849L4.35716 2.47737Z"
                            fill="green"
                            />
                        </svg>
        
                        <svg
                            v-else
                            class="fill-meta-5"
                            width="10"
                            height="11"
                            viewBox="0 0 10 11"
                            fill="#FF0000"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                            d="M5.64284 7.69237L9.09102 4.33987L10 5.22362L5 10.0849L-8.98488e-07 5.22362L0.908973 4.33987L4.35716 7.69237L4.35716 0.0848701L5.64284 0.0848704L5.64284 7.69237Z"
                            fill="#FF0000"
                            />
                        </svg>
        
                        <span :class="mthPurchasesRate > 0 ? 'text-success' : 'text-danger'"> than yesterday</span>
        
                        </div>
                    </div>
                </div>
    
                <div class="warehouse-inventory-card">
                <p>Total Credit Notes this Month</p>
                <div class="total">
                    <strong>{{ monthPurchases }}</strong>
                    <div>
                    <span :class="mthPurchasesRate > 0 ? 'text-success' : 'text-danger'">{{ mthPurchasesRate}} % </span>
                    <svg
                        v-if="mthPurchasesRate > 0"
                        class="fill-meta-3"
                        width="10"
                        height="11"
                        viewBox="0 0 10 11"
                        fill="green"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                        d="M4.35716 2.47737L0.908974 5.82987L5.0443e-07 4.94612L5 0.0848689L10 4.94612L9.09103 5.82987L5.64284 2.47737L5.64284 10.0849L4.35716 10.0849L4.35716 2.47737Z"
                        fill="green"
                        />
                    </svg>
    
                    <svg
                        v-else
                        class="fill-meta-5"
                        width="10"
                        height="11"
                        viewBox="0 0 10 11"
                        fill="#FF0000"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                        d="M5.64284 7.69237L9.09102 4.33987L10 5.22362L5 10.0849L-8.98488e-07 5.22362L0.908973 4.33987L4.35716 7.69237L4.35716 0.0848701L5.64284 0.0848704L5.64284 7.69237Z"
                        fill="#FF0000"
                        />
                    </svg>
    
                    <span :class="mthPurchasesRate > 0 ? 'text-success' : 'text-danger'"> than yesterday</span>
    
                    </div>
                </div>
                </div>
            </div>

            <div class="today-order-wrapper bg-white p-30">
                <div class="row">
                <div class="col-md-6 align-self-center">
                    <h5 class="fw-bold">Sales Analysis</h5>
                <div class="line-chart">
                    <LineChart 
                       
                    />
                </div>
                </div>
                <div class="col-md-6 align-self-center">
                    <h5 class="fw-bold">Sales Categories</h5>
                    <div class="bar-chart">
                    <BarChart/>
                    </div>
                </div>
                </div>
            </div>
            <div class="system-user-manual bg-white">
                <div class="row">
                </div>
            </div>
            </div>
        </div>
    </div>

</template>

<script>

import Header from '../../components/Header';
import LineChart from '../../components/LineChart';
import BarChart from '../../components/BarChart';
import { countTodayValues, countYesterdayValues, countThisMonthValues, countLastMonthValues, calculateRate } from '../../utils/commons'

export default{
    name: 'DashboardPage',
    components: {
        Header,
        LineChart,
        BarChart
    },
    
    data(){
        return{
        token: JSON.parse(localStorage.getItem('access_token')),
        date_now: new Date().getDate()+"/"+(new Date().getUTCMonth() + 1)+"/"+new Date().getFullYear()+"  "+new Date().getHours()+":"+new Date().getMinutes(),
        url: process.env.VUE_APP_URL,
        todaySales: 0,
        monthSales: 0,
        daySalesRate: 0.0,
        mthSalesRate: 0.0,

        monthPurchases: 0,
        mthPurchasesRate: 0.0,

        xValues: [],
        yValues: []
        }
    },

    methods:{
        async getSales () {
            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
            };
            const res = await fetch(process.env.VUE_APP_URL+'/sales', requestOptions)
            const data = await res.json()
        
            if(data.status == true){
                const sales= data.sales
                const todaySales = countTodayValues(sales)
                const yesterdaySales = countYesterdayValues(sales) 
                this.todaySales = todaySales
                this.daySalesRate =  Math.round(calculateRate(todaySales,yesterdaySales))


                const mthSales = countThisMonthValues(sales)
                const yesterMthSales = countLastMonthValues(sales)
                this.monthSales = mthSales
                this.mthSalesRate = Math.round(calculateRate(mthSales, yesterMthSales))
            }
        },
        async getPurchases () {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        
        this.loading = true
        const res = await fetch(process.env.VUE_APP_URL + '/purchases', requestOptions);
        const data = await res.json();

        if (data.status === true) {
            const purchases = data.purchases;
            const mthPurchases = countThisMonthValues(purchases)
            const yesterMthPurchases = countLastMonthValues(purchases)
            this.monthPurchases = mthPurchases
            this.mthPurchasesRate = Math.round(calculateRate(mthPurchases, yesterMthPurchases))
        } 
        }
    },


}




</script>